import { useState, useEffect } from "react";

import {
    TextField, Stack, ToggleButton, ToggleButtonGroup, Typography,
    List, ListItemButton, ListItemText, ListItemAvatar, Avatar
} from "@mui/material";

import { regex_dec, regex_num, regex_two_dec } from '../../../../constants/regex';

const PromoOneDialog = ({
    promo, brands, promotionData, setPromotionData
}) => {
    const { pkg_qty, discount, discount_type, brand: main_brand } = promotionData;

    const [data, setData] = useState({
        label: '%',
        maxLength: 5,
        helperText: '% de descuento'
    });
    const { label, maxLength, helperText } = data;

    const [disabled, setDisabled] = useState({
        isFieldDisabled: false,
        isButtonDisabled: false
    });
    const { isFieldDisabled, isButtonDisabled } = disabled;

    const setTextData = () => {
        if (discount_type === 'fixed')
            setData(e => ({
                ...e, label: 'Descuento ($)',
                maxLength: 10,
                helperText: `$${discount} de descuento (después de IVA)`
            }));
        else if (discount_type === 'percentage')
            setData(e => ({
                ...e, label: 'Descuento (%)',
                maxLength: 5,
                helperText: `${discount}% de descuento`
            }));
        else
            setData(e => ({
                ...e, label: 'X',
                maxLength: 1,
                helperText: `Descuento incorrecto`
            }));
    };

    useEffect(() => {
        if (discount_type === 'fixed') {
            if (discount !== '' && !regex_two_dec.test(discount))
                setPromotionData(e => ({ ...e, discount: '' }));
            else
                setTextData();
        } else if (discount_type === 'percentage') {
            if (discount !== '' && !regex_num.test(discount))
                setPromotionData(e => ({ ...e, discount: '' }));
            else
                setTextData();
        } else
            setPromotionData(e => ({ ...e, discount: '' }));
    }, [discount_type]);

    useEffect(() => {
        if (promo === 'DescuentoPieza')
            setDisabled(e => ({ ...e, isFieldDisabled: true, isButtonDisabled: false }));
        else if (promo === 'DescuentoMarca')
            setDisabled(e => ({ ...e, isFieldDisabled: false, isButtonDisabled: true }));
        else
            setDisabled(e => ({ ...e, isFieldDisabled: false, isButtonDisabled: false }));
    }, [promo]);

    useEffect(() => {
        setTextData();
    }, [promo, discount]);

    const handleAlignment = (event, newAlignment) => {
        if (newAlignment !== null)
            setPromotionData(e => ({ ...e, discount_type: newAlignment }));
    };

    const handleListItemClick = (event, index) => {
        setPromotionData(e => ({ ...e, brand: index }));
    };

    const handleInputChange = ({ target }) => {
        const name = target.name;
        const value = target.value;
        if (name === 'discount') {
            if (discount_type === 'fixed') {
                if (value === '' || regex_dec.test(value))
                    setPromotionData(e => ({ ...e, discount: value }));
            } else {
                if (value === '' || regex_num.test(value))
                    setPromotionData(e => ({ ...e, discount: value }));
            }
        } else if (name === 'pkg_qty') {
            if (['CompraXDescuento'].includes(promo)) {
                if (value === '' || regex_num.test(value))
                    setPromotionData(e => ({ ...e, pkg_qty: value }));
            }
        }
    };

    return (
        <Stack spacing={2} mt={2}>
            {
                ['DescuentoProducto', 'CompraDescuento', 'CompraABDescuento', 'CompraXDescuento', 'DescuentoPieza', 'DescuentoMarca'].includes(promo) &&
                    <>
                        <ToggleButtonGroup
                            sx={{ mt: 1 }}
                            color="primary"
                            value={discount_type}
                            exclusive
                            onChange={handleAlignment}
                            aria-label="discount"
                            >
                            <ToggleButton value="type" disabled>Tipo descuento</ToggleButton>
                            <ToggleButton value="percentage">%</ToggleButton>
                            <ToggleButton value="fixed" disabled={ isButtonDisabled }>$</ToggleButton>
                        </ToggleButtonGroup>

                        <TextField fullWidth
                            name="discount"
                            label={ label }
                            variant="standard"
                            inputProps={{ maxLength }}
                            helperText={ helperText }
                            value={ discount }
                            onChange={ handleInputChange }
                        />
                    </>
            }
            
            {
                ['CompraXDescuento', 'DescuentoPieza'].includes(promo) &&
                    <TextField fullWidth
                        disabled={ isFieldDisabled }
                        name="pkg_qty"
                        label="Cantidad necesaria para aplicar descuento"
                        variant="standard"
                        inputProps={{ maxLength: 2 }}
                        helperText={ `${pkg_qty} Pack`.trim() }
                        value={ pkg_qty }
                        onChange={ handleInputChange }
                    />
            }

            {
                promo === 'DescuentoMarca' &&
                    <>
                        <Typography variant="body1" gutterBottom>
                            Marcas disponibles
                        </Typography>
                        <List
                            sx={{
                                width: '100%',
                                maxWidth: 360,
                                bgcolor: 'background.paper',
                                position: 'relative',
                                overflow: 'auto',
                                maxHeight: 300,
                                '& ul': { padding: 0 }
                            }}>
                            {
                                brands.map(({ brand, url, image_id }) =>
                                    <ListItemButton key={url}
                                        selected={ brand === main_brand }
                                        onClick={
                                            (event) => handleListItemClick(event, brand)
                                        }>
                                        <ListItemAvatar>
                                            <Avatar alt={ url } src={ image_id } />
                                        </ListItemAvatar>
                                        <ListItemText primary={ brand } />
                                    </ListItemButton>
                                )
                            }
                        </List>
                    </>
            }
        </Stack>
    );
};

export default PromoOneDialog;